import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Navigation } from "../../components/Navigation";
import { User } from "lucide-react";
import { useNoindex } from "../../hooks/useNoindex";

export const CustomerLoginPage = () => {
  useNoindex();
  const { loginCustomer, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Accedi al tuo account | Edicola Cerasuolo";
    if (user && user.role === 'customer') {
      window.location.href = '/account';
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await loginCustomer(email.trim().toLowerCase(), password, rememberMe);
    setLoading(false);
    if (result.success) {
      window.location.href = '/account';
    } else {
      setError(result.error || 'Errore di accesso');
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <Navigation />
      <div className="max-w-md mx-auto px-4 py-12">
        <div className="bg-[#12121a] border border-gray-800 rounded-2xl p-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-500/10 rounded-full mb-4">
              <User className="w-8 h-8 text-amber-400" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">Accedi al tuo account</h1>
            <p className="text-gray-500 text-sm">Bentornato! Inserisci le tue credenziali</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="customer-login-form">
            <div>
              <label className="block text-sm text-gray-400 mb-1">Email</label>
              <input
                type="email"
                required
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-[#0a0a0f] border border-gray-700 rounded-lg text-white focus:border-amber-500 focus:outline-none"
                placeholder="email@esempio.it"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-1">Password</label>
              <input
                type="password"
                required
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-[#0a0a0f] border border-gray-700 rounded-lg text-white focus:border-amber-500 focus:outline-none"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-lg p-3">
                {error}
              </div>
            )}
            <label className="flex items-center gap-2 text-sm text-gray-400 select-none cursor-pointer">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                data-testid="login-remember-me"
                className="w-4 h-4 rounded border-gray-600 bg-[#0a0a0f] text-amber-500 focus:ring-amber-500 focus:ring-offset-0"
              />
              Resta connesso per 30 giorni
            </label>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="w-full py-3 bg-amber-500 hover:bg-amber-400 text-black font-bold rounded-lg transition disabled:opacity-60"
            >
              {loading ? 'Accesso in corso...' : 'Accedi'}
            </button>
          </form>

          <div className="mt-4 text-center">
            <a href="/password-dimenticata" data-testid="link-forgot-password" className="text-gray-400 hover:text-amber-400 text-sm">
              Password dimenticata?
            </a>
          </div>

          <div className="mt-6 text-center">
            <p className="text-gray-500 text-sm">
              Non hai un account?{' '}
              <a href="/registrazione" data-testid="link-to-register" className="text-amber-400 hover:text-amber-300 font-medium">
                Registrati gratis
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
